import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardService, DashboardStats } from '../../services/api/dashboard.service';

interface DashboardState {
    stats: DashboardStats | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: DashboardState = {
    stats: null,
    isLoading: false,
    error: null,
};

// Async Thunks
export const fetchDashboardStats = createAsyncThunk(
    'dashboard/fetchStats',
    async (_, { rejectWithValue }) => {
        try {
            const stats = await dashboardService.getStats();
            return stats;
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message || 'Error al cargar estadísticas del dashboard'
            );
        }
    }
);

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        clearDashboardError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDashboardStats.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchDashboardStats.fulfilled, (state, action) => {
                state.isLoading = false;
                state.stats = action.payload;
            })
            .addCase(fetchDashboardStats.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as string;
            });
    },
});

export const { clearDashboardError } = dashboardSlice.actions;

// Selectors
export const selectDashboardStats = (state: { dashboard: DashboardState }) => state.dashboard.stats;
export const selectDashboardLoading = (state: { dashboard: DashboardState }) => state.dashboard.isLoading;
export const selectDashboardError = (state: { dashboard: DashboardState }) => state.dashboard.error;

export default dashboardSlice.reducer;
